function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-31d76072\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/home/ec2-user/forgerock-ops-calsaws/3-configure/forgerock/IDM/configure/end-user-ui/node_modules/bootstrap/scss/_functions.scss\",\"/home/ec2-user/forgerock-ops-calsaws/3-configure/forgerock/IDM/configure/end-user-ui/node_modules/bootstrap/scss/_mixins.scss\",\"/home/ec2-user/forgerock-ops-calsaws/3-configure/forgerock/IDM/configure/end-user-ui/node_modules/bootstrap/scss/_variables.scss\",\"/home/ec2-user/forgerock-ops-calsaws/3-configure/forgerock/IDM/configure/end-user-ui/src/scss/theme-variables.scss\"]}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WorkflowControlWidget.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WorkflowControlWidget.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31d76072\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WorkflowControlWidget.vue"
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31d76072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/widgets/WorkflowControlWidget.vue
// module id = null
// module chunks = 